import React, { useState, useEffect, forwardRef } from 'react';
import { Fab, Input } from '@mui/material';
import { useRef } from 'react';
import { doc, getDoc } from 'firebase/firestore';
import Tooltip from '@mui/material/Tooltip';
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos';
import { useParams } from 'react-router-dom';
import { db } from '../../../firebase';
import Stack from '@mui/material/Stack';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';

const Alert = forwardRef(function Alert(props, ref) {
  return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});

const Form = ({ setFiles }) => {
  const fileRef = useRef();
  const [userData, setUserData] = useState([]);
  const { userId } = useParams();
  const [alert, setAlert] = useState('');
  const [alertText, setAlertText] = useState('');
  const [open, setOpen] = useState(false);
  const types = ['image/png', 'image/jpeg', 'image/svg+xml', 'image/gif'];

  const handleClick = () => {
    fileRef.current.click();
  };

  useEffect(() => {
    const fetchUser = async () => {
      try {
        const docRef = doc(db, 'users', userId);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          setUserData(docSnap.data());
        } else {
          console.log('No such document!');
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchUser();
  }, [userId]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setOpen(false);
  };
  const fileChangeHandler = (e) => {
    let selected = [...e.target.files];

    selected.forEach((el) => {
      if (el && types.includes(el.type)) {
        setFiles(selected);
      } else {
        setFiles([]);
        setOpen(true);
        setAlert('Please select a compatible file');
        setAlertText('error');
        console.log('Please select a compatible file');
      }
    });

    fileRef.current.value = null;
  };

  return (
    <form>
      <Input
        type="file"
        inputProps={{ multiple: true }}
        sx={{ display: 'none' }}
        inputRef={fileRef}
        onChange={fileChangeHandler}
      />
      <Stack spacing={2} sx={{ width: '100%' }}>
        <Snackbar open={open} autoHideDuration={3000} onClose={handleClose}>
          <Alert onClose={handleClose} severity={alertText} sx={{ width: '100%' }}>
            {alert}
          </Alert>
        </Snackbar>
      </Stack>
      {userData.space > 1 ? (
        <Tooltip title="Add Multiple Photos">
          <Fab color="primary" aria-label="add" sx={{ backgroundColor: '#7199ff' }} onClick={handleClick}>
            <AddToPhotosIcon sx={{ color: 'fff' }} />
          </Fab>
        </Tooltip>
      ) : (
        <Tooltip title="Add Multiple Photos">
          <Fab color="primary" aria-label="add" sx={{ backgroundColor: '#7199ff' }} disabled onClick={handleClick}>
            <AddToPhotosIcon sx={{ color: 'fff' }} />
          </Fab>
        </Tooltip>
      )}
    </form>
  );
};

export default Form;
